import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { toolInput } from "../tool-input";
import { linearIssueLabel } from "./linear-issue-label";

export const automationToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [HOST_TOOL_NAMES.LIST_AUTOMATIONS, () => labelOnly("Listed automations")],
  [HOST_TOOL_NAMES.GET_AUTOMATION, () => labelOnly("Read an automation")],
  [
    HOST_TOOL_NAMES.START_IMPLEMENT_SESSION,
    () => labelOnly("Started an Implement session"),
  ],
  [
    HOST_TOOL_NAMES.AUTOMATION_CATALOG,
    () => labelOnly("Read the automation catalog"),
  ],
  [
    HOST_TOOL_NAMES.CREATE_AUTOMATION,
    (record) => {
      const name = toolInput.trimmed(record.name);
      return labelOnly(
        name ? `Created automation ${name}` : "Created an automation",
      );
    },
  ],
  [
    HOST_TOOL_NAMES.UPDATE_AUTOMATION,
    (record) => {
      const name = toolInput.trimmed(record.name);
      return labelOnly(
        name ? `Updated automation ${name}` : "Updated an automation",
      );
    },
  ],
  [HOST_TOOL_NAMES.LINEAR_LIST_ISSUES, () => labelOnly("Listed Linear issues")],
  [
    HOST_TOOL_NAMES.LINEAR_GET_ISSUE,
    (record) => linearIssueLabel("Read Linear issue", record.issue),
  ],
  [
    HOST_TOOL_NAMES.LINEAR_CREATE_ISSUE,
    () => labelOnly("Created a Linear issue"),
  ],
  [
    HOST_TOOL_NAMES.LINEAR_UPDATE_ISSUE,
    (record) => linearIssueLabel("Updated Linear issue", record.issue),
  ],
  [
    HOST_TOOL_NAMES.LINEAR_COMMENT_ISSUE,
    (record) => linearIssueLabel("Commented on Linear issue", record.issue),
  ],
];
